//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {uuid} from '@/utils/util.js'
export default {
  name: 'VyCheckList',
  props: {
    isRadio: {type: Boolean, default: true}, // 是否单选
    options: {type: Array, required: true, default () { return [] }}, // 选项列表
    mapping: {type: Object}, // 多行显示映射表
    value: [String, Number, Array, Boolean],
    max: {type: Number, default: 1}, // 多选最大限制
    labelPosition: {type: String, default: 'left'}, // label的位置
    required: {type: Boolean, default: false}, // 是否必填
    disabled: Boolean, // 是否禁用
    checkDisabled: {type: Boolean, default: true},
  },
  data () {
    return {
      uuid: uuid(),
      currentRadioValue: '', // 当前单选值
      checkList: [], // 多选值
    }
  },
  computed: {
    radioValue: {
      get () {
        if(this.isRadio) return this.value
        else return ''
      },
      set (newValue) {
        this.currentRadioValue = newValue
        this.$emit('input', newValue)
        this.$emit('update:text', this.getLabelByKey(newValue, this.options))
        this.$emit('on-change', this.getItem(newValue))
      },
    },
  },
  watch: {
    // 由于外层的popup的should-rerender-on-show为true，每次进入都会刷新popup内的元素
    // 当popup显示时候，value已经传入了，如果immediate为false，该watch函数在初始化时候，不会执行
    value: {
      handler (newValue, oldValue) {
        if(!newValue) return
        if(this.isRadio) this.checkList = []
        else this.checkList = this.arrayTryParse(this.value)
      },
      immediate: true,
    },
  },
  methods: {
    getItem (key) {
      for(let item of this.options) {
        if(item.key === key) return item
      }
    },
    getItems (keys) {
      return keys.map((key) => {
        return this.getItem(key)
      })
    },
    getKey (item) { return typeof item === 'object' ? item.key : item },
    getLabel (item) { return typeof item === 'object' ? item.label : item },
    getInlineDesc (item) { return typeof item === 'object' ? item.inlineDesc : '' },
    isDisabled (key) {
      if(!this.checkDisabled) { return false }
      if(this.max > 1) { return !this.checkList.includes(key) && this.checkList.length === this.max }
      return false
    },
    getLabelByKey (key, list = []) {
      if(!list.length) return key
      const match = list.filter(item => item.key === key)
      if(match.length) return match[0].label || match[0].key
      return key
    },
    getLabelsByKeys (keys, list) { return keys.map(key => this.getLabelByKey(key, list)) },
    getFullValue () {
      if(this.isRadio) return {key: this.currentRadioValue, label: this.getLabelByKey(this.currentRadioValue, this.options)}
      return {list: this.checkList.map(key => ({key, label: this.getLabelByKey(key, this.options)})), keys: this.checkList, labels: this.checkList.map(key => this.getLabelByKey(key, this.options))}
    },
    arrayTryParse (item) {
      try {
        if(!item) return []
        if(Object.prototype.toString.call(item) === '[object Array]') return item
        let res = JSON.parse(item)
        if(Object.prototype.toString.call(res) === '[object Array]') return res
        else return Array.of(item)
      } catch (err) {
        console.log(err)
        return Array.of(item)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/basic/VyCheckList.vue